"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.QueryBuilderFactory = exports.FilterGroup = exports.FilterCondition = exports.FilterQueryError = exports.FilterValidationError = exports.LogicOperator = exports.SelectionOperator = exports.CheckboxOperator = exports.DateOperator = exports.NumberOperator = exports.TextOperator = exports.MongoOperator = void 0;
var field_1 = require("../field");
var default_filter_option_1 = require("./default-filter-option");
// MongoDB Operators Enum
var MongoOperator;
(function (MongoOperator) {
    // Comparison
    MongoOperator["EQ"] = "$eq";
    MongoOperator["NE"] = "$ne";
    MongoOperator["GT"] = "$gt";
    MongoOperator["GTE"] = "$gte";
    MongoOperator["LT"] = "$lt";
    MongoOperator["LTE"] = "$lte";
    MongoOperator["IN"] = "$in";
    MongoOperator["NIN"] = "$nin";
    // Logical
    MongoOperator["AND"] = "$and";
    MongoOperator["OR"] = "$or";
    MongoOperator["NOT"] = "$not";
    // Element
    MongoOperator["EXISTS"] = "$exists";
    // Evaluation
    MongoOperator["REGEX"] = "$regex";
    MongoOperator["EXPR"] = "$expr";
    // Array
    MongoOperator["ELEM_MATCH"] = "$elemMatch";
    // Aggregation Expression
    MongoOperator["TO_DOUBLE"] = "$toDouble";
})(MongoOperator = exports.MongoOperator || (exports.MongoOperator = {}));
// Filter Operators by Field Type
var TextOperator;
(function (TextOperator) {
    TextOperator["EQUALS"] = "equals";
    TextOperator["NOT_EQUALS"] = "not_equals";
    TextOperator["CONTAINS"] = "contains";
    TextOperator["NOT_CONTAINS"] = "not_contains";
    TextOperator["STARTS_WITH"] = "starts_with";
    TextOperator["NOT_STARTS_WITH"] = "not_starts_with";
    TextOperator["IS_EMPTY"] = "is_empty";
    TextOperator["IS_NOT_EMPTY"] = "is_not_empty";
})(TextOperator = exports.TextOperator || (exports.TextOperator = {}));
var NumberOperator;
(function (NumberOperator) {
    NumberOperator["EQUALS"] = "equals";
    NumberOperator["NOT_EQUALS"] = "not_equals";
    NumberOperator["GREATER_THAN"] = "greater_than";
    NumberOperator["GREATER_THAN_OR_EQUAL"] = "greater_than_or_equal";
    NumberOperator["LESS_THAN"] = "less_than";
    NumberOperator["LESS_THAN_OR_EQUAL"] = "less_than_or_equal";
    // BETWEEN = 'between',
    NumberOperator["IS_EMPTY"] = "is_empty";
    NumberOperator["IS_NOT_EMPTY"] = "is_not_empty";
})(NumberOperator = exports.NumberOperator || (exports.NumberOperator = {}));
var DateOperator;
(function (DateOperator) {
    DateOperator["EQUALS"] = "equals";
    DateOperator["NOT_EQUALS"] = "not_equals";
    DateOperator["BEFORE"] = "before";
    DateOperator["BEFORE_OR_EQUAL"] = "before_or_equal";
    DateOperator["AFTER"] = "after";
    DateOperator["AFTER_OR_EQUAL"] = "after_or_equal";
    // BETWEEN = 'between',
    DateOperator["IS_EMPTY"] = "is_empty";
    DateOperator["IS_NOT_EMPTY"] = "is_not_empty";
})(DateOperator = exports.DateOperator || (exports.DateOperator = {}));
var CheckboxOperator;
(function (CheckboxOperator) {
    CheckboxOperator["EQUALS"] = "equals";
    CheckboxOperator["NOT_EQUALS"] = "not_equals";
    CheckboxOperator["IS_EMPTY"] = "is_empty";
    CheckboxOperator["IS_NOT_EMPTY"] = "is_not_empty";
})(CheckboxOperator = exports.CheckboxOperator || (exports.CheckboxOperator = {}));
var SelectionOperator;
(function (SelectionOperator) {
    SelectionOperator["IS_ANY"] = "is_any";
    SelectionOperator["IS_NONE_OF"] = "is_none_of";
    SelectionOperator["IS_EMPTY"] = "is_empty";
    SelectionOperator["IS_NOT_EMPTY"] = "is_not_empty";
})(SelectionOperator = exports.SelectionOperator || (exports.SelectionOperator = {}));
// Logic operators for conditions
var LogicOperator;
(function (LogicOperator) {
    LogicOperator["AND"] = "and";
    LogicOperator["OR"] = "or";
})(LogicOperator = exports.LogicOperator || (exports.LogicOperator = {}));
// Custom error classes
var FilterValidationError = /** @class */ (function (_super) {
    __extends(FilterValidationError, _super);
    function FilterValidationError(message, field, operator) {
        var _this = _super.call(this, message) || this;
        _this.field = field;
        _this.operator = operator;
        _this.name = 'FilterValidationError';
        return _this;
    }
    return FilterValidationError;
}(Error));
exports.FilterValidationError = FilterValidationError;
var FilterQueryError = /** @class */ (function (_super) {
    __extends(FilterQueryError, _super);
    function FilterQueryError(message, field) {
        var _this = _super.call(this, message) || this;
        _this.field = field;
        _this.name = 'FilterQueryError';
        return _this;
    }
    return FilterQueryError;
}(Error));
exports.FilterQueryError = FilterQueryError;
// Variable resolver utility
var VariableResolver = /** @class */ (function () {
    function VariableResolver() {
    }
    VariableResolver.resolveUserVariable = function (value, context) {
        if (value === default_filter_option_1.DefaultUserFilterOption.CURRENT_USER) {
            return context.userId || null;
        }
        return value;
    };
    VariableResolver.resolveDateVariable = function (value, context) {
        var now = new Date();
        var timezone = context.timezone || 'UTC';
        // Helper function to get start/end of day in milliseconds
        var getStartOfDay = function (date) {
            var start = new Date(date);
            start.setHours(0, 0, 0, 0);
            return start.getTime();
        };
        var getEndOfDay = function (date) {
            var end = new Date(date);
            end.setHours(23, 59, 59, 999);
            return end.getTime();
        };
        switch (value) {
            case default_filter_option_1.DefaultDateFilterOption.TODAY:
                return {
                    start: getStartOfDay(now),
                    end: getEndOfDay(now)
                };
            case default_filter_option_1.DefaultDateFilterOption.YESTERDAY:
                var yesterday = new Date(now);
                yesterday.setDate(yesterday.getDate() - 1);
                return {
                    start: getStartOfDay(yesterday),
                    end: getEndOfDay(yesterday)
                };
            case default_filter_option_1.DefaultDateFilterOption.THIS_WEEK:
                var startOfWeek = new Date(now);
                startOfWeek.setDate(now.getDate() - now.getDay());
                var endOfWeek = new Date(startOfWeek);
                endOfWeek.setDate(startOfWeek.getDate() + 6);
                return {
                    start: getStartOfDay(startOfWeek),
                    end: getEndOfDay(endOfWeek)
                };
            case default_filter_option_1.DefaultDateFilterOption.LAST_WEEK:
                var lastWeekStart = new Date(now);
                lastWeekStart.setDate(now.getDate() - now.getDay() - 7);
                var lastWeekEnd = new Date(lastWeekStart);
                lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
                return {
                    start: getStartOfDay(lastWeekStart),
                    end: getEndOfDay(lastWeekEnd)
                };
            case default_filter_option_1.DefaultDateFilterOption.THIS_MONTH:
                var startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                var endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                return {
                    start: getStartOfDay(startOfMonth),
                    end: getEndOfDay(endOfMonth)
                };
            case default_filter_option_1.DefaultDateFilterOption.LAST_MONTH:
                var lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                var lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
                return {
                    start: getStartOfDay(lastMonthStart),
                    end: getEndOfDay(lastMonthEnd)
                };
            case default_filter_option_1.DefaultDateFilterOption.THIS_YEAR:
                var startOfYear = new Date(now.getFullYear(), 0, 1);
                var endOfYear = new Date(now.getFullYear(), 11, 31);
                return {
                    start: getStartOfDay(startOfYear),
                    end: getEndOfDay(endOfYear)
                };
            case default_filter_option_1.DefaultDateFilterOption.LAST_YEAR:
                var lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
                var lastYearEnd = new Date(now.getFullYear() - 1, 11, 31);
                return {
                    start: getStartOfDay(lastYearStart),
                    end: getEndOfDay(lastYearEnd)
                };
            default:
                return value;
        }
    };
    return VariableResolver;
}());
// Abstract base query builder
var BaseQueryBuilder = /** @class */ (function () {
    function BaseQueryBuilder() {
    }
    BaseQueryBuilder.prototype.validateString = function (value, context) {
        if (typeof value !== 'string') {
            throw new FilterQueryError("Expected string for ".concat(context, ", got ").concat(typeof value));
        }
        return value;
    };
    BaseQueryBuilder.prototype.validateStringArray = function (value, context) {
        if (!Array.isArray(value) || !value.every(function (v) { return typeof v === 'string'; })) {
            throw new FilterQueryError("Expected string array for ".concat(context));
        }
        return value;
    };
    BaseQueryBuilder.prototype.validateNumericString = function (value, context) {
        var num = parseFloat(value);
        if (isNaN(num)) {
            throw new FilterQueryError("Invalid numeric value \"".concat(value, "\" for ").concat(context));
        }
        return num;
    };
    BaseQueryBuilder.prototype.escapeRegex = function (str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    BaseQueryBuilder.prototype.handleEmptyOperations = function (fieldName, operator) {
        var _a, _b, _c, _d;
        if (operator === 'is_empty') {
            return _a = {}, _a[fieldName] = (_b = {}, _b[MongoOperator.IN] = [null, "", []], _b), _a;
        }
        if (operator === 'is_not_empty') {
            return _c = {}, _c[fieldName] = (_d = {}, _d[MongoOperator.NIN] = [null, "", []], _d), _c;
        }
        return null;
    };
    BaseQueryBuilder.prototype.isEmptyValue = function (value) {
        return value === '' || value === null || value === undefined;
    };
    BaseQueryBuilder.prototype.shouldSkipCondition = function (operator, value) {
        // Skip condition if value is empty unless it's an empty/not empty operator
        if (this.isEmptyValue(value)) {
            return operator !== 'is_empty' && operator !== 'is_not_empty';
        }
        return false;
    };
    return BaseQueryBuilder;
}());
// Text field query builder
var TextQueryBuilder = /** @class */ (function (_super) {
    __extends(TextQueryBuilder, _super);
    function TextQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        // Resolve user variables
        var resolvedValue = context ? VariableResolver.resolveUserVariable(value, context) : value;
        if (resolvedValue === null) {
            return null; // Skip condition if user variable can't be resolved
        }
        var stringValue = this.validateString(resolvedValue, 'text operation');
        switch (operator) {
            case TextOperator.EQUALS:
                return _a = {}, _a[fieldName] = stringValue, _a;
            case TextOperator.NOT_EQUALS:
                return _b = {}, _b[fieldName] = (_c = {}, _c[MongoOperator.NE] = stringValue, _c), _b;
            case TextOperator.CONTAINS:
                return _d = {}, _d[fieldName] = (_e = {}, _e[MongoOperator.REGEX] = this.escapeRegex(stringValue), _e.$options = 'i', _e), _d;
            case TextOperator.NOT_CONTAINS:
                return _f = {}, _f[fieldName] = (_g = {}, _g[MongoOperator.NOT] = (_h = {}, _h[MongoOperator.REGEX] = this.escapeRegex(stringValue), _h.$options = 'i', _h), _g), _f;
            case TextOperator.STARTS_WITH:
                return _j = {}, _j[fieldName] = (_k = {}, _k[MongoOperator.REGEX] = "^".concat(this.escapeRegex(stringValue)), _k.$options = 'i', _k), _j;
            case TextOperator.NOT_STARTS_WITH:
                return _l = {}, _l[fieldName] = (_m = {}, _m[MongoOperator.NOT] = (_o = {}, _o[MongoOperator.REGEX] = "^".concat(this.escapeRegex(stringValue)), _o.$options = 'i', _o), _m), _l;
            default:
                throw new FilterQueryError("Unsupported text operator: ".concat(operator), fieldName);
        }
    };
    return TextQueryBuilder;
}(BaseQueryBuilder));
// Number field query builder (values stored as strings)
var NumberQueryBuilder = /** @class */ (function (_super) {
    __extends(NumberQueryBuilder, _super);
    function NumberQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        // if (operator === NumberOperator.BETWEEN) {
        //     if (!extraValue) {
        //         throw new FilterQueryError('Between operation requires extra_value', fieldName);
        //     }
        //     const fromNum = this.validateNumericString(this.validateString(value, 'between from'), 'between from');
        //     const toNum = this.validateNumericString(extraValue, 'between to');
        //     return {
        //         [MongoOperator.EXPR]: {
        //             [MongoOperator.AND]: [
        //                 { [MongoOperator.GTE]: [{ [MongoOperator.TO_DOUBLE]: `$${fieldName}` }, fromNum] },
        //                 { [MongoOperator.LTE]: [{ [MongoOperator.TO_DOUBLE]: `$${fieldName}` }, toNum] }
        //             ]
        //         }
        //     };
        // }
        var numValue = this.validateNumericString(this.validateString(value, 'number operation'), 'number operation');
        switch (operator) {
            case NumberOperator.EQUALS:
                return _a = {}, _a[MongoOperator.EXPR] = (_b = {}, _b[MongoOperator.EQ] = [(_c = {}, _c[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _c), numValue], _b), _a;
            case NumberOperator.NOT_EQUALS:
                return _d = {}, _d[MongoOperator.EXPR] = (_e = {}, _e[MongoOperator.NE] = [(_f = {}, _f[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _f), numValue], _e), _d;
            case NumberOperator.GREATER_THAN:
                return _g = {}, _g[MongoOperator.EXPR] = (_h = {}, _h[MongoOperator.GT] = [(_j = {}, _j[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _j), numValue], _h), _g;
            case NumberOperator.GREATER_THAN_OR_EQUAL:
                return _k = {}, _k[MongoOperator.EXPR] = (_l = {}, _l[MongoOperator.GTE] = [(_m = {}, _m[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _m), numValue], _l), _k;
            case NumberOperator.LESS_THAN:
                return _o = {}, _o[MongoOperator.EXPR] = (_p = {}, _p[MongoOperator.LT] = [(_q = {}, _q[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _q), numValue], _p), _o;
            case NumberOperator.LESS_THAN_OR_EQUAL:
                return _r = {}, _r[MongoOperator.EXPR] = (_s = {}, _s[MongoOperator.LTE] = [(_t = {}, _t[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _t), numValue], _s), _r;
            default:
                throw new FilterQueryError("Unsupported number operator: ".concat(operator), fieldName);
        }
    };
    return NumberQueryBuilder;
}(BaseQueryBuilder));
// Date field query builder (handles number timestamps and date ranges)
var DateQueryBuilder = /** @class */ (function (_super) {
    __extends(DateQueryBuilder, _super);
    function DateQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        // Resolve date variables
        var resolvedValue = context ? VariableResolver.resolveDateVariable(value, context) : value;
        // Handle date ranges (for dynamic date variables)
        if (typeof resolvedValue === 'object' && 'start' in resolvedValue) {
            var start = resolvedValue.start, end = resolvedValue.end;
            // For date ranges, we need to handle different operators appropriately
            switch (operator) {
                case DateOperator.EQUALS:
                    // For ranges, "equals" means falls within the range
                    if (end) {
                        return _a = {},
                            _a[MongoOperator.EXPR] = (_b = {},
                                _b[MongoOperator.AND] = [
                                    (_c = {}, _c[MongoOperator.GTE] = [(_d = {}, _d[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _d), start], _c),
                                    (_e = {}, _e[MongoOperator.LTE] = [(_f = {}, _f[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _f), end], _e)
                                ],
                                _b),
                            _a;
                    }
                    else {
                        return _g = {}, _g[MongoOperator.EXPR] = (_h = {}, _h[MongoOperator.EQ] = [(_j = {}, _j[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _j), start], _h), _g;
                    }
                case DateOperator.NOT_EQUALS:
                    // For ranges, "not equals" means doesn't fall within the range
                    if (end) {
                        return _k = {},
                            _k[MongoOperator.EXPR] = (_l = {},
                                _l[MongoOperator.OR] = [
                                    (_m = {}, _m[MongoOperator.LT] = [(_o = {}, _o[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _o), start], _m),
                                    (_p = {}, _p[MongoOperator.GT] = [(_q = {}, _q[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _q), end], _p)
                                ],
                                _l),
                            _k;
                    }
                    else {
                        return _r = {}, _r[MongoOperator.EXPR] = (_s = {}, _s[MongoOperator.NE] = [(_t = {}, _t[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _t), start], _s), _r;
                    }
                case DateOperator.BEFORE:
                    return _u = {}, _u[MongoOperator.EXPR] = (_v = {}, _v[MongoOperator.LT] = [(_w = {}, _w[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _w), start], _v), _u;
                case DateOperator.BEFORE_OR_EQUAL:
                    return _x = {}, _x[MongoOperator.EXPR] = (_y = {}, _y[MongoOperator.LTE] = [(_z = {}, _z[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _z), end || start], _y), _x;
                case DateOperator.AFTER:
                    return _0 = {}, _0[MongoOperator.EXPR] = (_1 = {}, _1[MongoOperator.GT] = [(_2 = {}, _2[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _2), end || start], _1), _0;
                case DateOperator.AFTER_OR_EQUAL:
                    return _3 = {}, _3[MongoOperator.EXPR] = (_4 = {}, _4[MongoOperator.GTE] = [(_5 = {}, _5[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _5), start], _4), _3;
                default:
                    throw new FilterQueryError("Unsupported date operator for range: ".concat(operator), fieldName);
            }
        }
        // Handle single timestamp values
        // if (operator === DateOperator.BETWEEN) {
        //     if (!extraValue) {
        //         throw new FilterQueryError('Between operation requires extra_value', fieldName);
        //     }
        //     const fromTimestamp = typeof resolvedValue === 'number' ? resolvedValue : this.validateNumericString(this.validateString(resolvedValue, 'from timestamp'), 'from timestamp');
        //     const toTimestamp = typeof extraValue === 'number' ? extraValue : this.validateNumericString(extraValue, 'to timestamp');
        //     return {
        //         [MongoOperator.EXPR]: {
        //             [MongoOperator.AND]: [
        //                 { [MongoOperator.GTE]: [{ [MongoOperator.TO_DOUBLE]: `$${fieldName}` }, fromTimestamp] },
        //                 { [MongoOperator.LTE]: [{ [MongoOperator.TO_DOUBLE]: `$${fieldName}` }, toTimestamp] }
        //             ]
        //         }
        //     };
        // }
        var timestampValue = typeof resolvedValue === 'number' ? resolvedValue : this.validateNumericString(this.validateString(resolvedValue, 'timestamp value'), 'timestamp value');
        switch (operator) {
            case DateOperator.EQUALS:
                // For equals operation, convert single timestamp to full day range
                // This ensures that searching for "31 Jul" matches all records from that day
                var dateFromTimestamp = new Date(timestampValue);
                var startOfDay = new Date(dateFromTimestamp);
                startOfDay.setHours(0, 0, 0, 0);
                var endOfDay = new Date(dateFromTimestamp);
                endOfDay.setHours(23, 59, 59, 999);
                return _6 = {},
                    _6[MongoOperator.EXPR] = (_7 = {},
                        _7[MongoOperator.AND] = [
                            (_8 = {}, _8[MongoOperator.GTE] = [(_9 = {}, _9[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _9), startOfDay.getTime()], _8),
                            (_10 = {}, _10[MongoOperator.LTE] = [(_11 = {}, _11[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _11), endOfDay.getTime()], _10)
                        ],
                        _7),
                    _6;
            case DateOperator.NOT_EQUALS:
                return _12 = {}, _12[MongoOperator.EXPR] = (_13 = {}, _13[MongoOperator.NE] = [(_14 = {}, _14[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _14), timestampValue], _13), _12;
            case DateOperator.BEFORE:
                return _15 = {}, _15[MongoOperator.EXPR] = (_16 = {}, _16[MongoOperator.LT] = [(_17 = {}, _17[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _17), timestampValue], _16), _15;
            case DateOperator.BEFORE_OR_EQUAL:
                return _18 = {}, _18[MongoOperator.EXPR] = (_19 = {}, _19[MongoOperator.LTE] = [(_20 = {}, _20[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _20), timestampValue], _19), _18;
            case DateOperator.AFTER:
                return _21 = {}, _21[MongoOperator.EXPR] = (_22 = {}, _22[MongoOperator.GT] = [(_23 = {}, _23[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _23), timestampValue], _22), _21;
            case DateOperator.AFTER_OR_EQUAL:
                return _24 = {}, _24[MongoOperator.EXPR] = (_25 = {}, _25[MongoOperator.GTE] = [(_26 = {}, _26[MongoOperator.TO_DOUBLE] = "$".concat(fieldName), _26), timestampValue], _25), _24;
            default:
                throw new FilterQueryError("Unsupported date operator: ".concat(operator), fieldName);
        }
    };
    return DateQueryBuilder;
}(BaseQueryBuilder));
// Checkbox field query builder
var CheckboxQueryBuilder = /** @class */ (function (_super) {
    __extends(CheckboxQueryBuilder, _super);
    function CheckboxQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        var checkboxStringValue = this.validateString(value, 'checkbox operation');
        // Convert string 'true'/'false' to boolean true/false
        var checkboxValue = this.convertStringToBoolean(checkboxStringValue);
        switch (operator) {
            case CheckboxOperator.EQUALS:
                return _a = {}, _a[fieldName] = checkboxValue, _a;
            case CheckboxOperator.NOT_EQUALS:
                return _b = {}, _b[fieldName] = (_c = {}, _c[MongoOperator.NE] = checkboxValue, _c), _b;
            default:
                throw new FilterQueryError("Unsupported checkbox operator: ".concat(operator), fieldName);
        }
    };
    CheckboxQueryBuilder.prototype.convertStringToBoolean = function (value) {
        var lowerValue = value.toLowerCase().trim();
        if (lowerValue === 'true') {
            return true;
        }
        else if (lowerValue === 'false') {
            return false;
        }
        else {
            throw new FilterQueryError("Invalid boolean string: ".concat(value, ". Expected 'true' or 'false'"));
        }
    };
    return CheckboxQueryBuilder;
}(BaseQueryBuilder));
// Selection field query builder (handles semicolon-separated values)
var SelectionQueryBuilder = /** @class */ (function (_super) {
    __extends(SelectionQueryBuilder, _super);
    function SelectionQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        // Resolve user variables
        var resolvedValue = context ? VariableResolver.resolveUserVariable(value, context) : value;
        if (resolvedValue === null) {
            return null; // Skip condition if user variable can't be resolved
        }
        switch (operator) {
            case SelectionOperator.IS_ANY:
                if (Array.isArray(resolvedValue)) {
                    return _a = {}, _a[fieldName] = (_b = {}, _b[MongoOperator.IN] = resolvedValue, _b), _a;
                }
                else {
                    var stringValue = this.validateString(resolvedValue, 'is_any operation');
                    // Handle semicolon-separated values
                    if (stringValue.includes(';')) {
                        var values = stringValue.split(';').map(function (v) { return v.trim(); }).filter(function (v) { return v; });
                        return _c = {}, _c[fieldName] = (_d = {}, _d[MongoOperator.IN] = values, _d), _c;
                    }
                    return _e = {}, _e[fieldName] = stringValue, _e;
                }
            case SelectionOperator.IS_NONE_OF:
                if (Array.isArray(resolvedValue)) {
                    return _f = {}, _f[fieldName] = (_g = {}, _g[MongoOperator.NIN] = resolvedValue, _g), _f;
                }
                else {
                    var stringValue = this.validateString(resolvedValue, 'is_none_of operation');
                    // Handle semicolon-separated values
                    if (stringValue.includes(';')) {
                        var values = stringValue.split(';').map(function (v) { return v.trim(); }).filter(function (v) { return v; });
                        return _h = {}, _h[fieldName] = (_j = {}, _j[MongoOperator.NIN] = values, _j), _h;
                    }
                    return _k = {}, _k[fieldName] = (_l = {}, _l[MongoOperator.NE] = stringValue, _l), _k;
                }
            default:
                throw new FilterQueryError("Unsupported selection operator: ".concat(operator), fieldName);
        }
    };
    return SelectionQueryBuilder;
}(BaseQueryBuilder));
// Multiselect field query builder (handles semicolon-separated input values and stored values)
var MultiSelectQueryBuilder = /** @class */ (function (_super) {
    __extends(MultiSelectQueryBuilder, _super);
    function MultiSelectQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiSelectQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c, _d, _e;
        var _this = this;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        var values;
        if (Array.isArray(value)) {
            values = value;
        }
        else {
            var stringValue = this.validateString(value, 'multiselect operation');
            // Handle semicolon-separated input values
            values = stringValue.split(';').map(function (v) { return v.trim(); }).filter(function (v) { return v; });
        }
        switch (operator) {
            case SelectionOperator.IS_ANY:
                var anyRegex = values.map(function (v) { return "(^|;)".concat(_this.escapeRegex(v), "(;|$)"); }).join('|');
                return _a = {}, _a[fieldName] = (_b = {}, _b[MongoOperator.REGEX] = anyRegex, _b.$options = 'i', _b), _a;
            case SelectionOperator.IS_NONE_OF:
                var noneRegex = values.map(function (v) { return "(^|;)".concat(_this.escapeRegex(v), "(;|$)"); }).join('|');
                return _c = {}, _c[fieldName] = (_d = {}, _d[MongoOperator.NOT] = (_e = {}, _e[MongoOperator.REGEX] = noneRegex, _e.$options = 'i', _e), _d), _c;
            default:
                throw new FilterQueryError("Unsupported multiselect operator: ".concat(operator), fieldName);
        }
    };
    return MultiSelectQueryBuilder;
}(BaseQueryBuilder));
// Array field query builder (email/phone arrays)
var ArrayFieldQueryBuilder = /** @class */ (function (_super) {
    __extends(ArrayFieldQueryBuilder, _super);
    function ArrayFieldQueryBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArrayFieldQueryBuilder.prototype.buildQuery = function (fieldName, operator, value, extraValue, context) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        if (this.shouldSkipCondition(operator, value)) {
            return null;
        }
        var emptyResult = this.handleEmptyOperations(fieldName, operator);
        if (emptyResult)
            return emptyResult;
        var stringValue = this.validateString(value, 'array field operation');
        switch (operator) {
            case TextOperator.EQUALS:
                return _a = {}, _a[fieldName] = (_b = {}, _b[MongoOperator.ELEM_MATCH] = { value: stringValue }, _b), _a;
            case TextOperator.NOT_EQUALS:
                return _c = {}, _c[fieldName] = (_d = {}, _d[MongoOperator.NOT] = (_e = {}, _e[MongoOperator.ELEM_MATCH] = { value: stringValue }, _e), _d), _c;
            case TextOperator.CONTAINS:
                return _f = {}, _f[fieldName] = (_g = {}, _g[MongoOperator.ELEM_MATCH] = { value: (_h = {}, _h[MongoOperator.REGEX] = this.escapeRegex(stringValue), _h.$options = 'i', _h) }, _g), _f;
            case TextOperator.NOT_CONTAINS:
                return _j = {}, _j[fieldName] = (_k = {}, _k[MongoOperator.NOT] = (_l = {}, _l[MongoOperator.ELEM_MATCH] = { value: (_m = {}, _m[MongoOperator.REGEX] = this.escapeRegex(stringValue), _m.$options = 'i', _m) }, _l), _k), _j;
            case TextOperator.STARTS_WITH:
                return _o = {}, _o[fieldName] = (_p = {}, _p[MongoOperator.ELEM_MATCH] = { value: (_q = {}, _q[MongoOperator.REGEX] = "^".concat(this.escapeRegex(stringValue)), _q.$options = 'i', _q) }, _p), _o;
            case TextOperator.NOT_STARTS_WITH:
                return _r = {}, _r[fieldName] = (_s = {}, _s[MongoOperator.NOT] = (_t = {}, _t[MongoOperator.ELEM_MATCH] = { value: (_u = {}, _u[MongoOperator.REGEX] = "^".concat(this.escapeRegex(stringValue)), _u.$options = 'i', _u) }, _t), _s), _r;
            default:
                throw new FilterQueryError("Unsupported array field operator: ".concat(operator), fieldName);
        }
    };
    return ArrayFieldQueryBuilder;
}(BaseQueryBuilder));
// Filter Condition
var FilterCondition = /** @class */ (function () {
    function FilterCondition(field_name, operator, value, extra_value, field_type) {
        this.field_name = field_name;
        this.operator = operator;
        this.value = value;
        this.extra_value = extra_value;
        this.field_type = field_type;
    }
    FilterCondition.fromJSON = function (json) {
        return new FilterCondition(json.field_name, json.operator, json.value, json.extra_value, json.field_type);
    };
    FilterCondition.prototype.toMongoQuery = function (context) {
        try {
            if (!this.field_type) {
                // Default to text query if field type is not specified
                var textBuilder = new TextQueryBuilder();
                return textBuilder.buildQuery(this.field_name, this.operator, this.value, this.extra_value, context);
            }
            var factory = QueryBuilderFactory.getInstance();
            var builder = factory.getBuilder(this.field_type);
            return builder.buildQuery(this.field_name, this.operator, this.value, this.extra_value, context);
        }
        catch (error) {
            if (error instanceof FilterQueryError || error instanceof FilterValidationError) {
                throw error;
            }
            throw new FilterQueryError("Failed to build query for field \"".concat(this.field_name, "\": ").concat(error.message), this.field_name);
        }
    };
    return FilterCondition;
}());
exports.FilterCondition = FilterCondition;
// Filter Group
var FilterGroup = /** @class */ (function () {
    function FilterGroup(logic, conditions) {
        if (conditions === void 0) { conditions = []; }
        this.logic = logic;
        this.conditions = conditions;
    }
    FilterGroup.fromJSON = function (json) {
        var logic = json.logic;
        var conditions = Array.isArray(json.conditions)
            ? json.conditions.map(function (c) { return FilterCondition.fromJSON(c); })
            : [];
        return new FilterGroup(logic, conditions);
    };
    FilterGroup.prototype.addCondition = function (condition) {
        this.conditions.push(condition);
    };
    FilterGroup.prototype.toMongoQuery = function (context) {
        var _a, _b;
        try {
            if (this.conditions.length === 0) {
                return {};
            }
            var mongoConditions = this.conditions
                .map(function (condition) { return condition.toMongoQuery(context); }) // Pass context here
                .filter(function (condition) { return condition && Object.keys(condition).length > 0; });
            if (mongoConditions.length === 0)
                return {};
            if (mongoConditions.length === 1)
                return mongoConditions[0];
            return this.logic === LogicOperator.AND
                ? (_a = {}, _a[MongoOperator.AND] = mongoConditions, _a) : (_b = {}, _b[MongoOperator.OR] = mongoConditions, _b);
        }
        catch (error) {
            if (error instanceof FilterQueryError || error instanceof FilterValidationError) {
                throw error;
            }
            throw new FilterQueryError("Failed to build query for filter group: ".concat(error.message));
        }
    };
    return FilterGroup;
}());
exports.FilterGroup = FilterGroup;
// Query builder factory
var QueryBuilderFactory = /** @class */ (function () {
    function QueryBuilderFactory() {
        this.builders = new Map();
        this.initializeBuilders();
    }
    QueryBuilderFactory.getInstance = function () {
        if (!QueryBuilderFactory.instance) {
            QueryBuilderFactory.instance = new QueryBuilderFactory();
        }
        return QueryBuilderFactory.instance;
    };
    QueryBuilderFactory.prototype.initializeBuilders = function () {
        var textBuilder = new TextQueryBuilder();
        var arrayFieldBuilder = new ArrayFieldQueryBuilder();
        var numberBuilder = new NumberQueryBuilder();
        var dateBuilder = new DateQueryBuilder();
        var checkboxBuilder = new CheckboxQueryBuilder();
        var selectionBuilder = new SelectionQueryBuilder();
        var multiSelectBuilder = new MultiSelectQueryBuilder();
        this.builders.set(field_1.FieldType.SINGLE_LINE_TEXT, textBuilder);
        this.builders.set(field_1.FieldType.MULTI_LINE_TEXT, textBuilder);
        this.builders.set(field_1.FieldType.RICH_TEXT, textBuilder);
        this.builders.set(field_1.FieldType.EMAIL, arrayFieldBuilder);
        this.builders.set(field_1.FieldType.PHONE, arrayFieldBuilder);
        this.builders.set(field_1.FieldType.NUMBER, numberBuilder);
        this.builders.set(field_1.FieldType.DATE, dateBuilder);
        this.builders.set(field_1.FieldType.DATE_AND_TIME, dateBuilder);
        this.builders.set(field_1.FieldType.CHECKBOX, checkboxBuilder);
        this.builders.set(field_1.FieldType.DROPDOWN, selectionBuilder);
        this.builders.set(field_1.FieldType.MULTI_SELECT_DROPDOWN, multiSelectBuilder);
        this.builders.set(field_1.FieldType.USER, selectionBuilder);
    };
    QueryBuilderFactory.prototype.getBuilder = function (fieldType) {
        var builder = this.builders.get(fieldType);
        if (!builder) {
            throw new FilterQueryError("No query builder found for field type: ".concat(fieldType));
        }
        return builder;
    };
    return QueryBuilderFactory;
}());
exports.QueryBuilderFactory = QueryBuilderFactory;
